import { EducationModule } from "@js/components/EducationCourse/eduConfig";
import { level1ModuleCompleteColor } from "@js/educationContent/CairoMummiesContent/eduConstants";
import Ribbon0 from "@js/public/images/Ribbon0.svg";
import StarklingsLogo from "@js/public/images/StarklingsLogo.svg";
import {
    lesson0DefaultEndCode,
    lesson0DefaultMiddleCode,
    lesson0DefaultStartCode,
} from "./lesson0";
import {
    lesson1DefaultEndCode,
    lesson1DefaultMiddleCode,
    lesson1DefaultStartCode,
} from "./lesson1";
import {
    lesson2DefaultEndCode,
    lesson2DefaultMiddleCode,
    lesson2DefaultStartCode,
} from "./lesson2";
import {
    lesson3DefaultEndCode,
    lesson3DefaultMiddleCode,
    lesson3DefaultStartCode,
} from "./lesson3";
import {
    lesson4DefaultEndCode,
    lesson4DefaultMiddleCode,
    lesson4DefaultStartCode,
} from "./lesson4";
import {
    lesson5DefaultEndCode,
    lesson5DefaultMiddleCode,
    lesson5DefaultStartCode,
} from "./lesson5";
import { m1l0Solution } from "./lesson0Solution";
import { m1l1Solution } from "./lesson1Solution";
import { m1l2Solution } from "./lesson2Solution";
import { m1l3Solution } from "./lesson3Solution";
import { m1l4Solution } from "./lesson4Solution";
import { m1l5Solution } from "./lesson5Solution";

[
    {
        type: "paragraph",
        children: [
            {
                text: "In Cairo, variables are immutable by default. When a variable is immutable, once a value is bound to a name, you can’t change that value. You can make them mutable by adding mut in front of the variable name.",
            },
        ],
    },
    {
        type: "paragraph",
        children: [
            {
                text: "It is however important to clarify the fact that even though the variable can be made mutable, Cairo works with an immutable memory model, meaning that changing the value of a variable will not change the value in memory but rather assign a new memory location to that variable.",
            },
        ],
    },
    {
        type: "paragraph",
        children: [
            {
                text: "Further information",
            },
        ],
    },
    {
        type: "bulleted-list",
        children: [
            {
                type: "list-item",
                children: [
                    {
                        text: "",
                    },
                    {
                        type: "link",
                        url: "https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#memory-model",
                        children: [
                            {
                                text: "Memory model (from Cairo 0)",
                            },
                        ],
                    },
                    {
                        text: "",
                    },
                ],
            },
            {
                type: "list-item",
                children: [
                    {
                        text: "",
                    },
                    {
                        type: "link",
                        url: "https://cairo-book.github.io/ch02-01-variables-and-mutability.html",
                        children: [
                            {
                                text: "Variables",
                            },
                        ],
                    },
                    {
                        text: "",
                    },
                ],
            },
            {
                type: "list-item",
                children: [
                    {
                        text: "",
                    },
                    {
                        type: "link",
                        url: "https://cairo-book.github.io/ch02-02-data-types.html#integer-types",
                        children: [
                            {
                                text: "Integer types",
                            },
                        ],
                    },
                    {
                        text: "",
                    },
                ],
            },
        ],
    },
];

export const starklings1VariablesConfig: EducationModule = {
    solution: "",
    imgSrc: StarklingsLogo.src,
    moduleInfo: {
        id: 1,
        moduleName: "starklings1Variables",
        timeEstimate: "20-30 min",
        title: "Starklings 1.0  Variables",
        description: `Welcome to the intro of Starklings 1.0 Variables lessons. Good luck!`,
        moduleComplete: {
            badgeName: "STARKLINGS 1.0 VARIABLES",
            badgeCaption: "A level 1 Starkling 1.0",
            ribbonImgSrc: Ribbon0.src,
            badgeImgSrc: StarklingsLogo.src,
            imgColor: level1ModuleCompleteColor,
            badgeTokenId: 14,
        },
    },
    lessons: [
        {
            timeEstimate: "5 min",
            title: "Variables00",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "An immutable variable is one whose value cannot be changed after it is set. In Cairo, variables are immutable by default. You can make them mutable by adding mut in front of the variable name." } ] }, { "type": "paragraph", "children": [ { "text": "It is however important to clarify the fact that even though the variable can be made mutable, Cairo works with an immutable memory model, meaning that changing the value of a variable will not change the value in memory but rather assign a new memory location to that variable." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#memory-model", "children": [ { "text": "Memory model (from Cairo 0)" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-01-variables-and-mutability.html", "children": [ { "text": "Variables" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "Integer types" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson0DefaultStartCode,
            defaultMiddleCode: lesson0DefaultMiddleCode,
            defaultEndCode: lesson0DefaultEndCode,
            id: 0,
            solution: m1l0Solution,
        },
        {
            timeEstimate: "5 min",
            title: "Variables01",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "An immutable variable is one whose value cannot be changed after it is set. In Cairo, variables are immutable by default. You can make them mutable by adding mut in front of the variable name." } ] }, { "type": "paragraph", "children": [ { "text": "It is however important to clarify the fact that even though the variable can be made mutable, Cairo works with an immutable memory model, meaning that changing the value of a variable will not change the value in memory but rather assign a new memory location to that variable." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#memory-model", "children": [ { "text": "Memory model (from Cairo 0)" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-01-variables-and-mutability.html", "children": [ { "text": "Variables" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "Integer types" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson1DefaultStartCode,
            defaultEndCode: lesson1DefaultEndCode,
            defaultMiddleCode: lesson1DefaultMiddleCode,
            id: 1,
            solution: m1l1Solution,
        },
        {
            timeEstimate: "5 min",
            title: "Variables02",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "An immutable variable is one whose value cannot be changed after it is set. In Cairo, variables are immutable by default. You can make them mutable by adding mut in front of the variable name." } ] }, { "type": "paragraph", "children": [ { "text": "It is however important to clarify the fact that even though the variable can be made mutable, Cairo works with an immutable memory model, meaning that changing the value of a variable will not change the value in memory but rather assign a new memory location to that variable." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#memory-model", "children": [ { "text": "Memory model (from Cairo 0)" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-01-variables-and-mutability.html", "children": [ { "text": "Variables" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "Integer types" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson2DefaultStartCode,
            defaultMiddleCode: lesson2DefaultMiddleCode,
            defaultEndCode: lesson2DefaultEndCode,
            id: 2,
            solution: m1l2Solution,
        },
        {
            timeEstimate: "5 min",
            title: "Variables03",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "An immutable variable is one whose value cannot be changed after it is set. In Cairo, variables are immutable by default. You can make them mutable by adding mut in front of the variable name." } ] }, { "type": "paragraph", "children": [ { "text": "It is however important to clarify the fact that even though the variable can be made mutable, Cairo works with an immutable memory model, meaning that changing the value of a variable will not change the value in memory but rather assign a new memory location to that variable." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#memory-model", "children": [ { "text": "Memory model (from Cairo 0)" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-01-variables-and-mutability.html", "children": [ { "text": "Variables" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "Integer types" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson3DefaultStartCode,
            defaultMiddleCode: lesson3DefaultMiddleCode,
            defaultEndCode: lesson3DefaultEndCode,
            id: 3,
            solution: m1l3Solution,
        },
        {
            timeEstimate: "5 min",
            title: "Variables04",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "An immutable variable is one whose value cannot be changed after it is set. In Cairo, variables are immutable by default. You can make them mutable by adding mut in front of the variable name." } ] }, { "type": "paragraph", "children": [ { "text": "It is however important to clarify the fact that even though the variable can be made mutable, Cairo works with an immutable memory model, meaning that changing the value of a variable will not change the value in memory but rather assign a new memory location to that variable." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#memory-model", "children": [ { "text": "Memory model (from Cairo 0)" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-01-variables-and-mutability.html", "children": [ { "text": "Variables" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "Integer types" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson4DefaultStartCode,
            defaultMiddleCode: lesson4DefaultMiddleCode,
            defaultEndCode: lesson4DefaultEndCode,
            id: 4,
            solution: m1l4Solution,
        },
        {
            timeEstimate: "5 min",
            title: "Variables05",
            formattedDescription: `
[ { "type": "paragraph", "children": [ { "text": "An immutable variable is one whose value cannot be changed after it is set. In Cairo, variables are immutable by default. You can make them mutable by adding mut in front of the variable name." } ] }, { "type": "paragraph", "children": [ { "text": "It is however important to clarify the fact that even though the variable can be made mutable, Cairo works with an immutable memory model, meaning that changing the value of a variable will not change the value in memory but rather assign a new memory location to that variable." } ] }, { "type": "paragraph", "children": [ { "text": "Further information" } ] }, { "type": "bulleted-list", "children": [ { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#memory-model", "children": [ { "text": "Memory model (from Cairo 0)" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-01-variables-and-mutability.html", "children": [ { "text": "Variables" } ] }, { "text": "" } ] }, { "type": "list-item", "children": [ { "text": "" }, { "type": "link", "url": "https://cairo-book.github.io/ch02-02-data-types.html#integer-types", "children": [ { "text": "Integer types" } ] }, { "text": "" } ] } ] } ]
`,
            hints: [],
            defaultStartCode: lesson5DefaultStartCode,
            defaultMiddleCode: lesson5DefaultMiddleCode,
            defaultEndCode: lesson5DefaultEndCode,
            id: 5,
            solution: m1l5Solution,
        },
    ],
};
